import { LiquidString } from '../common/LiquidString.js';
import { RuntimeComponent } from './RuntimeComponent.js'

class DesigntimeComponent extends RuntimeComponent {
    type;
    name;

    constructor(identifyer, version) {
        super(identifyer, version);

        this.type = this.constructor.staticId;
        this.name = this.constructor.staticName;
    }

    getDesignerView(outputs) {
        return this.getDefaultDesignerView(this.id, this.values, this.valueUpdated.bind(this), this.params, outputs, this.paramsUpdated.bind(this));
    }

    getDefaultDesignerView(id, inputfields, inputfieldUpdatedCallback, params, outputs, paramsUpdatedCallback) {
        var $designer = $("<div class='my-3'></div>");

        for (var inputfieldKey in inputfields) {
            var inputfieldValue = inputfields[inputfieldKey].value;
            var translated = !inputfields[inputfieldKey].dontTranslate;
            var description = inputfields[inputfieldKey].description;

            let isLiquid = inputfields[inputfieldKey] instanceof LiquidString;

            var classname = "input_" + inputfieldKey;
            var uniqueId = id + "_input_" + inputfieldKey;
            var $formgroup = $("<div class='form-group'></div>");
            if (isLiquid)
                $formgroup.append($("<label for='" + uniqueId + "'>" + inputfieldKey + " (Liquid/Markdown)</label>"));
            else if (!translated)
                $formgroup.append($("<label for='" + uniqueId + "'>" + inputfieldKey + " (Not translated)</label>"));
            else
                $formgroup.append($("<label for='" + uniqueId + "'>" + inputfieldKey + "</label>"));
            var $input = $("<textarea id='" + uniqueId + "' class='form-control " + classname + "' data-key='" + inputfieldKey + "' >" + inputfieldValue + "</textarea>");
            $formgroup.append($input);
            if (description)
                $formgroup.append(`<small>${description}</small>`);

            $input.change(function (e) {
                var key = $(e.currentTarget).data("key");
                var value = $(e.currentTarget).val();
                inputfieldUpdatedCallback(key, value);
            }.bind(this));
            $designer.append($formgroup);
        }

        if (params) {
            for (var paramIndex in params) {
                var param = params[paramIndex];
                var $dropdown = this.getOutputDropDown(id, paramIndex, outputs, param.key, paramsUpdatedCallback);
                $designer.append($dropdown);
            }
        }

        return $designer;
    }

    valueUpdated(key, newValue) {
        this.values[key].value = newValue;
    }

    paramsUpdated(key, newValue) {
        this.params[key].key = newValue;
    }

    exportModel() {
        let model = {
            version: this.version,
            id: this.id,
            values: {},
            params: this.params
        };

        for (var i in this.values) {
            if (!model.values[i])
                model.values[i] = {};

            model.values[i].value = this.values[i].value;
        }

        return model;
    }

    updatePointers(newIds) {
        var res = [];

        for (var i in this.params) {
            var param = this.params[i];
            for (var newId in newIds) {
                if (param.key.includes(newId)) {
                    res.push(this.id + " " + i + ": " + newId + " -> " + newIds[newId]);
                    param.key = param.key.replace(newId, newIds[newId]);
                }
            }
        }

        return res;
    }

    getOutputDropDown(id, key, outputs, selectedOutput, onChanged) {
        var uniqueId = id + "_input_" + key;
        var $formgroup = $("<div class='form-group'></div>");
        $formgroup.append($("<label for='" + uniqueId + "'>" + key + "</label>"));
        var $dropdown = $("<select class='form-select' id='" + uniqueId + "' data-key='" + key + "'></select>")
        for (var i in outputs) {
            $dropdown.append($("<option value='" + outputs[i].key + "'>" + outputs[i].key + "</option>"))
        }

        $dropdown.find("option[value='" + selectedOutput + "']").prop("selected", true);

        $dropdown.change(function (e) {
            var text = $(e.currentTarget).val();
            var key = $(e.currentTarget).data("key");
            onChanged(key, text);
        });

        $formgroup.append($dropdown);

        return $formgroup;
    }

}

export { DesigntimeComponent }
